import React, { useState, useEffect } from 'react';
import { Label } from "../atoms/label"
import useMedia from 'use-media';
import { PullDown } from "../atoms/pullDown";
import img_pull from '../../resources/icons/arw_pulldown.svg';
import {useStore} from "react-redux";
export const TimeSet = (props) => {
    const countData = [
        { option: "人数", value: 0 }, { option: "2名", value: 2 }, { option: "3名", value: 3 }, { option: "4名", value: 4 },
    ]
    const countDataSingle = [
        { option: "人数", value: 0 }, { option: "1名", value: 1 }, 
    ]
    console.log(countData)

    //レスポンシブ対応
    const isWidePhone = useMedia({ maxWidth: '480px' });
    const isWideTablet = useMedia({ maxWidth: '960px' });
    const [Phone, setPhone] = useState(false);
    const [Tablet, setTablet] = useState(false);
    const [reserveTypeFlg,setReserveTypeFlg] = useState(true);
    const store = useStore();
    useEffect(() => {
        if (isWideTablet && isWidePhone) {
            setPhone(true);
            setTablet(false);
        }
        else if (isWideTablet && !isWidePhone) {
            setPhone(false);
            setTablet(true);
        }
        else if (!isWideTablet && isWidePhone) {
            setTablet(false);
            setPhone(true);
        }
        else {
            setPhone(false);
            setTablet(false);
        }

    },[isWidePhone])
    
    useEffect(() => {
        const reserveType = store.getState().reserveType;
        if(reserveType === "request"){
            setReserveTypeFlg(false);
        }
    },[])

    let id_idx = -1;
    return (
        
        <div style={Phone ? styles.topSP : styles.top}>
            {reserveTypeFlg ?
                <div style={Phone ? styles.timeTitleSP : styles.timeTitle}>
                    <Label label={props.timeValue} style={styles.timeValue} />
                </div>
                :null
            }
            <div style={Phone ? styles.valueSP : styles.value} >
                {props.labels.map((label, idx) => {
                    //idsに格納されているデータのindexを操作
                    props.texts.includes(label) ? id_idx++ : id_idx = id_idx;
                    console.log(idx+"番目："+props.defaultValue[idx]+"人");
                    return (
                            <div style={props.texts.includes(label) ? (Phone ? styles.westSP : styles.west):(Phone ? styles.westGraySP : styles.westGray)}>
                                <Label label={label} style={props.texts.includes(label) ? isWidePhone ? styles.westTitlePullSp : styles.westTitlePull : isWidePhone ? styles.westTitleSp : styles.westTitle} />
                                {props.texts.includes(label) ?
                                    <PullDown
                                        selectStyle={styles.westCheck}
                                        data={props.reservePlanTime}
                                        id={props.id[id_idx]}
                                        onChange={props.onChange}
                                        selectedValue={props.defaultValue[idx]? props.defaultValue[idx] : 0}
                                    />
                                    :
                                    <Label label="×" style={styles.westValue} />
                                }
                            </div>
                    )
                })}
            </div>
        </div>
    );
};

const styles = {
    top: {
        display: "table",
        border: "solid 1px #CCCCCC",
        textAlign: "center",
    },
    topSP: {
        display: "table",
        textAlign: "center",
        width: "100%",
        border: "1px solid rgb(204, 204, 204)"
    },
    value: {
    },
    valueSP: {
        display:"block"
    },
    timeTitle: {
        display: "table-cell",
        width: "100px",
        height: "40px",
        verticalAlign: "middle",
        borderRight: "solid 1px #CCCCCC",
        backgroundColor: "#808080",
        color: "white",
        padding: "5px　10px",
    },
    timeValue: {
        fontWeight: "700",
    },
    timeTitleSP: {
        display: "table-cell",
        width: "30%",
        verticalAlign: "middle",
        borderRight: "solid 1px #CCCCCC",
        backgroundColor: "#808080",
        color: "white",
        padding: "10px",
    },
    west: {
        display: "table-cell",
        width: "190px",
        height: "40px",
        verticalAlign: "middle",
        borderRight: "solid 1px #CCCCCC",
        backgroundColor: "white",
        padding: "10px 15px",
        fontWeight: "bold",
    },
    westSP: {
        width: "calc(100% - 30px)",
        height: "40px",
        verticalAlign: "middle",
        borderBottom: "solid 1px #CCCCCC",
        backgroundColor: "white",
        padding: "10px 15px",
        fontWeight: "bold",
        display:"flex",
        justifyContent:"space-between",
        alignItems:"center"
    },
    westGray: {
        display: "table-cell",
        width: "190px",
        height: "40px",
        verticalAlign: "middle",
        borderRight: "solid 1px #CCCCCC",
        padding: "10px 15px",
        fontWeight: "bold",
        color: "#AAAAAA",
    },
    westGraySP: {
        width: "calc(100% - 30px)",
        height: "40px",
        verticalAlign: "middle",
        borderBottom: "solid 1px #CCCCCC",
        padding: "10px 15px",
        fontWeight: "bold",
        color: "#AAAAAA",
        lineHeight: "30px",
        display:"flex",
        justifyContent:"space-between",
        alignItems:"center"
    },
    westTitlePull: {
        float: "left",
        marginTop: "5px",
        fontSize: "small",
    },
    westTitlePullSp: {
        float: "left",
        fontSize: "small",
    },
    westTitle: {
        float: "left",
        marginTop: "5px",
        fontSize: "small",
    },
    westTitleSp: {
        float: "left",
        fontSize: "small",
    },
    westCheck: {
        float: "right",
        padding: "8px",
        width: "80px",
        webkitAppearance: "none",
        mozAppearance: "none",
        appearance: "none",
        backgroundImage: `url(${img_pull})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: "right 10px center",
        cursor: "pointer",
    },
    westValue: {
        float: "right",
        fontSize: "20px",
    },
    east: {
        display: "table-cell",
        width: "190px",
        height: "40px",
        verticalAlign: "middle",
        backgroundColor: "white",
        padding: "10px 15px",
        fontWeight: "bold",
    },
    eastSP: {
        display: "flex",
        width: "calc(100% - 30px)",
        height: "40px",
        justifyContent: "space-between",
        backgroundColor: "white",
        padding: "10px 15px",
        fontWeight: "bold",
    },
    eastGray: {
        display: "table-cell",
        width: "190px",
        height: "40px",
        verticalAlign: "middle",
        padding: "10px 15px",
        fontWeight: "bold",
        color: "#AAAAAA",
    },
    eastGraySP: {
        display: "table-cell",
        width: "calc(100% - 30px)",
        height: "40px",
        verticalAlign: "middle",
        padding: "10px 15px",
        fontWeight: "bold",
        color: "#AAAAAA",
    },
    eastTitlePull: {
        float: "left",
        marginTop: "5px",
        fontSize: "small",
    },
    eastTitle: {
        float: "left",
        marginTop: "5px",
        fontSize: "small",
        cursor: "pointer",
    },
    eastCheck: {
        float: "right",
        padding: "8px",
        width: "80px",
        webkitAppearance: "none",
        mozAppearance: "none",
        appearance: "none",
        backgroundImage: `url(${img_pull})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: "right 10px center",
        cursor: "pointer",
    },
    eastValue: {
        float: "right",
        fontSize: "20px",
    },
}